import OrderService from "./OrderService";

class OrderGroupService extends OrderService {
  constructor() {
    super("order_group");
  }

  fetchDeliveryEta(
    locationId: string,
    placedAtTimestamp: number
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      try {
        const formData = new FormData();
        formData.append("location_id", locationId);
        formData.append("placed_at_timestamp", `${placedAtTimestamp}`);
        this.http.post(`${this.model}/delivery_eta`, formData).then((data: any) => {
          if (data.code === 200) {
            resolve(data.message);
          } else reject({ message: data.message });
        });
      } catch (error) {
        reject({ message: "An unexpected error occured!" });
        throw error;
      }
    });
  }
}

export const orderGroupService = new OrderGroupService();
export default OrderGroupService;
